




























import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import debounce from 'debounce';
import { IField } from '@lib-shared/fields/types/field';
import { translate } from '@lib-shared/helpers/translation.helper';
import { EFieldSource } from '@lib-shared/fields/types/enums/field-source';

@Component
export default class TextField extends Vue {
  @Prop() field!: IField;
  @Prop() disabled!: boolean;
  @Prop() completed!: boolean;
  @Prop() fieldFocused?: boolean;
  @Prop() isConnectedToCurrentRecipient: boolean;

  focused = false;
  inputValue = '';
  debounceHandleInput: (value: string) => void = debounce(this.handleInput, 300);

  @Watch('fieldFocused')
  watchFieldFocused(fieldFocused: boolean) {
    if (fieldFocused) {
      const input: HTMLInputElement = this.$refs[this.field.id] as HTMLInputElement;
      input.focus({
        preventScroll: true,
      });
    }
  }

  get showInput(): boolean {
    return this.isConnectedToCurrentRecipient;
  }

  get showRequired(): boolean {
    if (this.focused || this.completed || this.disabled) {
      return false;
    }
    return this.field.isRequired;
  }

  get value(): string {
    if (this.field.source === EFieldSource.Sender) {
      return this.field.value;
    }
    return this.field.value || this.field.label || translate('enter-text-here');
  }

  get placeholder(): string {
    return this.field.label || translate('enter-text-here');
  }

  handleInput(value: string) {
    if (this.disabled) {
      return;
    }
    this.$emit('update', value);
  }

  handleFocus() {
    this.focused = true;
    this.$emit('focus');
  }

  handleBlur() {
    this.focused = false;
    this.$emit('blur');
  }

  mounted() {
    this.inputValue = this.field.value;
  }
}
